/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_TitleInputs */

const en_us2_progress_title = /** @type {(inputs: Progress_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progress`)
};

const pt_br2_progress_title = /** @type {(inputs: Progress_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progresso`)
};

const es_419_progress_title = /** @type {(inputs: Progress_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progreso`)
};

const pt_pt2_progress_title = /** @type {(inputs: Progress_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progresso`)
};

const fr_fr2_progress_title = /** @type {(inputs: Progress_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progression`)
};

const de_de2_progress_title = /** @type {(inputs: Progress_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortschritt`)
};

const it_it2_progress_title = /** @type {(inputs: Progress_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progressi`)
};

/**
* | output |
* | --- |
* | "Progress" |
*
* @param {Progress_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_title = /** @type {((inputs?: Progress_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_title(inputs)
	if (locale === "es-419") return es_419_progress_title(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_title(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_title(inputs)
	if (locale === "de-DE") return de_de2_progress_title(inputs)
	if (locale === "it-IT") return it_it2_progress_title(inputs)
	return en_us2_progress_title(inputs)
});
export { progress_title as "progress.title" }